import React, { useState } from "react";
import Shell from "@/components/Shell";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

const ProfilePage = () => {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({
    first_name: user?.first_name || "",
    age: user?.age || "",
    occupation: user?.occupation || "",
    gender: user?.gender || "",
  });
  const [saving, setSaving] = useState(false);

  if (!user) return null;
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await api.post("/profile", {
        first_name: form.first_name.trim(),
        age: parseInt(form.age, 10),
        occupation: form.occupation.trim(),
        gender: form.gender,
      });
      setUser(res.data);
      toast.success("Profile updated");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Shell title="Your Profile">
      <div className="overline mb-2">Signed in as</div>
      <div className="text-sm text-slate-700 mb-8" data-testid="profile-email">{user.email}</div>

      <form onSubmit={save} className="space-y-8">
        <div>
          <label className="overline block mb-2">First Name</label>
          <input
            data-testid="profile-first-name"
            className="mm-input"
            value={form.first_name}
            onChange={(e) => set("first_name", e.target.value)}
          />
        </div>
        <div>
          <label className="overline block mb-2">Age</label>
          <input
            data-testid="profile-age"
            className="mm-input"
            type="number"
            min={18}
            max={99}
            value={form.age}
            onChange={(e) => set("age", e.target.value)}
          />
        </div>
        <div>
          <label className="overline block mb-2">Occupation</label>
          <input
            data-testid="profile-occupation"
            className="mm-input"
            value={form.occupation}
            onChange={(e) => set("occupation", e.target.value)}
          />
        </div>
        <div>
          <label className="overline block mb-3">Gender</label>
          <div className="grid grid-cols-2 gap-3">
            {["male", "female"].map((g) => (
              <button
                key={g}
                type="button"
                data-testid={`profile-gender-${g}`}
                onClick={() => set("gender", g)}
                className={form.gender === g ? "mm-btn-primary" : "mm-btn-outline"}
                style={{ textTransform: "capitalize" }}
              >
                {g}
              </button>
            ))}
          </div>
        </div>
        <button type="submit" data-testid="profile-save" className="mm-btn-primary" disabled={saving}>
          {saving ? "Saving…" : "Save changes"}
        </button>
      </form>
    </Shell>
  );
};

export default ProfilePage;
